module.exports = __webpack_public_path__ + "img/p3.2e9f189.png";